import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/group/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/park/group/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/park/group/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/group/submit', params, options);

export const update = (params, options) => request.post('/api/park/group/submit', params, options);

export const getParkGroupList = (params, options) =>
  request.post('/api/park/group/selections', qs.stringify(params), options);
